/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Resource } from '@ngxp/rest';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ResourceRepository } from '../resource/resource.repository';
import { ResourceUriProps, SingleResourceLoadActions } from './actions';

export class ResourceEffects<T extends Resource> {
  constructor(
    private readonly actions$: Actions,
    private readonly repository: ResourceRepository,
    private readonly resourceActions: SingleResourceLoadActions,
  ) {}

  loadByUri$ = createEffect(() =>
    this.actions$.pipe(
      ofType(this.resourceActions.loadAction),
      switchMap((props: ResourceUriProps) => {
        return this.repository.getResource<T>(props.resourceUri).pipe(
          map((resource: T) => this.resourceActions.loadSuccessAction({ resource })),
          catchError((error) => of(this.resourceActions.loadFailureAction({ error }))),
        );
      }),
    ),
  );
}
